/* const colorMap = {
 *   NPER: "color(display-p3 0.8824 0.3412 0.3490)",
 *   PMT: "#0d5fb6",
 *   FV: "#BE4BDB",
 *   RATE: "#a8692a",
 *   PV: "#62a900",
 * } as const; */
export const colorMap = {
  NPER: "#FF4552",
  PMT: "#008FD3",
  FV: "#BE4BDB",
  RATE: "#32B67A",
  PV: "#BEA1A5",
} as const;

type PColorText = {
  txt: keyof typeof colorMap;
};

type Keys = keyof typeof colorMap;

const hasKey = (k: string): k is Keys => k in colorMap;

export function getColor(key: Keys): (typeof colorMap)[typeof key];
export function getColor(key: string): undefined;
export function getColor(key: string) {
  if (hasKey(key)) {
    return colorMap[key];
  }
  return undefined;
}

export const ColorText = ({ txt }: PColorText) => {
  const color = getColor(txt);
  return <span style={color ? { color } : {}}>{txt}</span>;
};
